/* tslint:disable */

import Moment from 'moment';
import { Log } from 'ng2-logger';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { Common } from '../../../../core/common';
import Translator from '../../../../core/i18n';
import { IAction, IAppState } from '../../../../models/action/core';
import { IActivityStatsProps } from '../../../../models/components/activity-report-modal';
import { ActivityTypeEnums } from '../../../../models/enums/ActivityType';
const _logger = Log.create('Processing Activity');
const T = Translator.create();
let _common: Common;

class ReportModalDetails extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    render() {
        return (
            <div className="col-12 px-0 report_section_container">
                {this.props.ActivityReportDetail ?
                    <div className="row">
                        <div className="col d-flex justify-content-center">
                            <div className="report_icon">
                                <img src={_common.GetDefaultIcons('filledperson')} alt="" />
                            </div>
                            <div className="report_icon_text">
                                <span className="icon_text_medium">{T.t('r_gen_exam_session_detail_student_count')}</span>
                                <span className="icon_text_small">{this.props.ActivityReportDetail.studentCount ? this.props.ActivityReportDetail.studentCount : '-'}</span>
                            </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                            <div className="report_icon">
                                <img src={_common.GetDefaultIcons('filledeye')} alt="" />
                            </div>
                            <div className="report_icon_text">
                                <span className="icon_text_medium">{T.t('r_display')}</span>
                                <span className="icon_text_small">{this.props.ActivityReportDetail.activityViewCount ? this.props.ActivityReportDetail.activityViewCount : '-'}</span>
                            </div>
                        </div>
                        {(this.props.ActivityReportDetail.activityType ? this.props.ActivityReportDetail.activityType : ActivityTypeEnums.Other) === ActivityTypeEnums.Document ?
                            <div className="col d-flex justify-content-center">
                                <div className="report_icon">
                                    <img src={_common.GetDefaultIcons('filleddownload')} alt="" />
                                </div>
                                <div className="report_icon_text">
                                    <span className="icon_text_medium">{T.t('r_downloads')}</span>
                                    <span className="icon_text_small">{this.props.ActivityReportDetail.activityDownloadCount ? this.props.ActivityReportDetail.activityDownloadCount : '-'}</span>
                                </div>
                            </div>
                            : ''}
                        {(this.props.ActivityReportDetail.activityType ? this.props.ActivityReportDetail.activityType : ActivityTypeEnums.Other) === ActivityTypeEnums.Assignment ?
                            <>
                                <div className="col d-flex justify-content-center">
                                    <div className="report_icon">
                                        <img src={_common.GetDefaultIcons('filledupload')} alt="" />
                                    </div>
                                    <div className="report_icon_text">
                                        <span className="icon_text_medium">{T.t('r_uploads')}</span>
                                        <span className="icon_text_small">{this.props.ActivityReportDetail.activityUploadCount ? this.props.ActivityReportDetail.activityUploadCount : '-'}</span>
                                    </div>
                                </div>
                                <div className="col d-flex justify-content-center">
                                    <div className="report_icon">
                                        <img src={_common.GetDefaultIcons('fillednote')} alt="" />
                                    </div>
                                    <div className="report_icon_text">
                                        <span className="icon_text_medium">{T.t('r_average_score')}</span>
                                        <span className="icon_text_small">{this.props.ActivityReportDetail.averageScore ? this.props.ActivityReportDetail.averageScore : '-'}</span>
                                    </div>
                                </div>
                            </>
                            : ''}
                        {(this.props.ActivityReportDetail.activityType ? this.props.ActivityReportDetail.activityType : ActivityTypeEnums.Other) === ActivityTypeEnums.Forum ?
                            <>
                                <div className="col d-flex justify-content-center">
                                    <div className="report_icon">
                                        <img src={_common.GetDefaultIcons('filledback')} alt="" />
                                    </div>
                                    <div className="report_icon_text">
                                        <span className="icon_text_medium">{T.t('r_menu_message')} </span>
                                        <span className="icon_text_small">{this.props.ActivityReportDetail.forumMessageCount ? this.props.ActivityReportDetail.forumMessageCount : '-'}</span>
                                    </div>
                                </div>
                            </>
                            : ''}
                        {(this.props.ActivityReportDetail.activityType ? this.props.ActivityReportDetail.activityType : ActivityTypeEnums.Other) === ActivityTypeEnums.Exam ?
                            <>
                                <div className="col d-flex justify-content-center">
                                    <div className="report_icon">
                                        <img src={_common.GetDefaultIcons('filledask')} alt=""/>
                                    </div>
                                    <div className="report_icon_text">
                                        <span className="icon_text_medium">{T.t('r_questions')}</span>
                                        <span className="icon_text_small">{this.props.ActivityReportDetail.examQuestionCount ? this.props.ActivityReportDetail.examQuestionCount : '-'}</span>
                                    </div>
                                </div>
                                <div className="col d-flex justify-content-center">
                                    <div className="report_icon">
                                        <img src={_common.GetDefaultIcons('filleddiscoss')} alt=""/>
                                    </div>
                                    <div className="report_icon_text">
                                        <span className="icon_text_medium">{T.t('r_pool_questions')}</span>
                                        <span className="icon_text_small">{this.props.ActivityReportDetail.questionPoolCount ? this.props.ActivityReportDetail.questionPoolCount : '-'}</span>
                                    </div>
                                </div>
                                <div className="col d-flex justify-content-center">
                                    <div className="report_icon">
                                        <img src={_common.GetDefaultIcons('fillednote')} alt=""/>
                                    </div>
                                    <div className="report_icon_text">
                                        <span className="icon_text_medium">{T.t('r_average_score')}</span>
                                        <span className="icon_text_small">{this.props.ActivityReportDetail.averageScore ? this.props.ActivityReportDetail.averageScore : '-'}</span>
                                    </div>
                                </div>
                            </>
                            : ''}
                        {(this.props.ActivityReportDetail.activityType ? this.props.ActivityReportDetail.activityType : ActivityTypeEnums.Other) === ActivityTypeEnums.VirtualClass ?
                            <>
                                <div className="col d-flex justify-content-center">
                                    <div className="report_icon">
                                        <img src={_common.GetDefaultIcons('filledtime')} alt=""/>
                                    </div>
                                    <div className="report_icon_text">
                                        <span className="icon_text_medium">{T.t('r_views')}</span>
                                        <span className="icon_text_small">{this.props.ActivityReportDetail.videoTotalDuration ? ( (this.props.ActivityReportDetail.videoTotalDuration / 60) > 1 ? (this.props.ActivityReportDetail.videoTotalDuration / 60).toFixed(0) + 'S ' : '' + (this.props.ActivityReportDetail.videoTotalDuration % 60).toFixed(0) + 'DK') : '-'}</span>
                                    </div>
                                </div>
                                {/* <div className="col d-flex justify-content-center">
                                    <div className="report_icon">
                                        <img src={_common.GetDefaultIcons('fillednone')} alt=""/>
                                    </div>
                                    <div className="report_icon_text">
                                        <span className="icon_text_medium">{T.t('r_virtual_class_repeat')}</span>
                                        <span className="icon_text_small">{this.props.ActivityReportDetail.virtualClassIsPacked ? 'Hazır' : 'Erişim Yok'}</span>
                                    </div>
                                </div> */}
                            </>
                            : ''}
                        {(this.props.ActivityReportDetail.activityType ? this.props.ActivityReportDetail.activityType : ActivityTypeEnums.Other) === ActivityTypeEnums.Survey ?
                            <>
                                <div className="col d-flex justify-content-center">
                                    <div className="report_icon">
                                        <img src={_common.GetDefaultIcons('filleddiscoss')} alt=""/>
                                    </div>
                                    <div className="report_icon_text">
                                        <span className="icon_text_medium">{T.t('r_questions')}</span>
                                        <span className="icon_text_small">{this.props.ActivityReportDetail.surveyQuestionCount ? this.props.ActivityReportDetail.surveyQuestionCount : '-'}</span>
                                    </div>
                                </div>
                            </>
                            : ''}
                        {(this.props.ActivityReportDetail.activityType ? this.props.ActivityReportDetail.activityType : ActivityTypeEnums.Other) === ActivityTypeEnums.Video ?
                            <>
                                <div className="col d-flex justify-content-center">
                                    <div className="report_icon">
                                        <img src={_common.GetDefaultIcons('filledtime')} alt="" />
                                    </div>
                                    <div className="report_icon_text">
                                        <span className="icon_text_medium">{T.t('r_views')}</span>
                                        <span className="icon_text_small">{this.props.ActivityReportDetail.videoTotalDuration ? ( (this.props.ActivityReportDetail.videoTotalDuration / 60) > 1 ? (this.props.ActivityReportDetail.videoTotalDuration / 60).toFixed(0) + 'S ' : '' + (this.props.ActivityReportDetail.videoTotalDuration % 60).toFixed(0) + 'DK') : '-'}</span>
                                    </div>
                                </div>
                                <div className="col d-flex justify-content-center">
                                    <div className="report_icon">
                                        <img src={_common.GetDefaultIcons('filledvideo')} alt="" />
                                    </div>
                                    <div className="report_icon_text">
                                        <span className="icon_text_medium">{T.t('r_average_duration')}</span>
                                        <span className="icon_text_small">{this.props.ActivityReportDetail.videoAverageDuration ? ( (this.props.ActivityReportDetail.videoAverageDuration / 60) > 1 ? (this.props.ActivityReportDetail.videoAverageDuration / 60).toFixed(0) + 'S ' : '' + (this.props.ActivityReportDetail.videoAverageDuration % 60).toFixed(0) + 'DK') : '-'}</span>
                                    </div>
                                </div>
                            </>
                            : ''}
                        {(this.props.ActivityReportDetail.activityType ? this.props.ActivityReportDetail.activityType : ActivityTypeEnums.Other) === ActivityTypeEnums.Elesson ?
                            <>
                                <div className="col d-flex justify-content-center">
                                    <div className="report_icon">
                                        <img src={_common.GetDefaultIcons('filledtime')} alt="" />
                                    </div>
                                    <div className="report_icon_text">
                                        <span className="icon_text_medium">{T.t('r_views')}</span>
                                        <span className="icon_text_small">{this.props.ActivityReportDetail.videoTotalDuration ? ( (this.props.ActivityReportDetail.videoTotalDuration / 60) > 1 ? (this.props.ActivityReportDetail.videoTotalDuration / 60).toFixed(0) + 'S ' : '' + (this.props.ActivityReportDetail.videoTotalDuration % 60).toFixed(0) + 'DK') : '-'}</span>
                                    </div>
                                </div>
                            </>
                            : ''}
                    </div> : ''}
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: any): any => {
    if (!state) {
        return ownProps;
    }
    const newProps: any = Object.assign({}, ownProps, {
        userType: state.login.identitiy.userType,
        coursePageClassId: state.coursePage.coursePageClassId,
        courseContentWeekActivities: state.coursePage.courseContentWeekActivities,
        courseContentMenuType: state.coursePage.courseContentMenuType,
        activityCardItems: state.coursePage.activityCard,
        classActivityReport: state.coursePage.classActivityReport,
        coursePageclassInformation: state.coursePage.coursePageclassInformation,
        userPreferences: state.profile.userPreferences.preferences,
        groupId: state.assignment.groupId
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.coursePage.classActivityReport === prev.coursePage.classActivityReport &&
        next.coursePage.activityCard === prev.coursePage.activityCard;
    return ret;
};

const CProcessingActivity = connect(
    mapStateToProps,
    dispatchProps,
    null,
    { areStatesEqual }
)(ReportModalDetails);

export default CProcessingActivity;
